import React from "react";
import Table from "../../../components/table/table";
import Icon from "../../../components/icon/icon";
import { Model } from "../../../types";
import { ModelTableProps } from "../types/models-types";
import { ITEMS_PER_PAGE_OPTIONS } from "../../../constants/pagination";

export const ModelTable: React.FC<ModelTableProps> = ({
  models,
  brands,
  isLoading,
  currentPage,
  itemsPerPage,
  totalPages,
  onEdit,
  onDelete,
  onPageChange,
  onItemsPerPageChange,
}) => {
  const columns = [
    {
      title: "Название",
      dataIndex: "name" as keyof Model,
      key: "name",
    },
    {
      title: "Бренд",
      key: "brand",
      dataIndex: "brandId" as keyof Model,
      render: (brandId: string) => {
        const brand = brands?.find((b) => b.id === brandId);
        return brand?.name || brandId;
      },
    },
    {
      title: "Действия",
      key: "action",
      dataIndex: "id" as keyof Model,
      render: (_: any, record: Model) => (
        <div className="models__actions">
          <button
            onClick={() => onEdit(record)}
            className="models__action-btn"
            title="Редактировать"
          >
            <Icon name="pencil" size="small" />
          </button>
          <button
            onClick={() => onDelete(record)}
            className="models__action-btn"
            title="Удалить"
          >
            <Icon name="delete" size="small" />
          </button>
        </div>
      ),
    },
  ];

  const handleItemsPerPageChange = (value: string): void => {
    onItemsPerPageChange(parseInt(value));
  };

  return (
    <div className="models__table-container">
      <Table
        columns={columns}
        dataSource={models}
        rowKey="id"
        loading={isLoading}
        emptyMessage="Модели не найдены"
        currentPage={currentPage}
        itemsPerPage={itemsPerPage}
      />

      <div className="models__pagination">
        <div className="models__pagination-info">
          Показано{" "}
          {Math.min((currentPage - 1) * itemsPerPage + 1, models.length)} -{" "}
          {Math.min(currentPage * itemsPerPage, models.length)} из{" "}
          {models.length}
        </div>

        <div className="models__pagination-controls">
          <select
            value={itemsPerPage}
            onChange={(e) => handleItemsPerPageChange(e.target.value)}
            className="models__page-size-select"
          >
            {ITEMS_PER_PAGE_OPTIONS.map((option) => (
              <option key={option} value={option}>
                {option} на странице
              </option>
            ))}
          </select>

          <div className="models__page-buttons">
            <button
              onClick={() => onPageChange(currentPage - 1)}
              disabled={currentPage === 1}
              className="models__page-btn"
            >
              <Icon name="left" size="small" />
            </button>

            <span className="models__page-info">
              {currentPage} из {totalPages}
            </span>

            <button
              onClick={() => onPageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              className="models__page-btn"
            >
              <Icon name="right" size="small" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
